module.exports = __webpack_public_path__ + "static/media/pin-primary-privado.c6aee885.png";